import { useEffect, useState, useRef } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { Landmark, Phone, BadgeDollarSign, GraduationCap, ChevronDown, ChevronUp } from "lucide-react"
import "./FastFacts.css"

const FastFacts = ({ countryData }) => {
  const fastFacts = countryData?.fastFacts || {}
  const [isExpanded, setIsExpanded] = useState(false)
  const [isOverflowing, setIsOverflowing] = useState(false)
  const textRef = useRef(null)

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(textRef.current.scrollHeight > 140) // Threshold for collapsed view
    }
  }, [fastFacts])

  const facts = [
    { label: "GDP", value: fastFacts?.gdp, icon: Landmark },
    { label: "Dialing Code", value: fastFacts?.dialingCode, icon: Phone },
    { label: "Currency", value: fastFacts?.currency, icon: BadgeDollarSign },
    { label: "Universities", value: fastFacts?.universities, icon: GraduationCap },
  ]

  return (
    <div className="fast-facts-container">
      <div className="facts-grid">
        {facts.map((fact, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            viewport={{ once: true }}
            className="fact-card"
          >
            <div className="fact-icon">
              <fact.icon />
            </div>
            <div className="fact-content">
              <h3>{fact.label}</h3>
              <p>{fact.value || "N/A"}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="why-study-section"
      >
        <h2>Why Study in {countryData?.name || "this country"}?</h2>
        <div ref={textRef} className={`why-study-text ${isExpanded ? 'expanded' : 'collapsed'}`}>
          <p>{fastFacts?.whyStudy || "Discover the unique education advantages of this destination."}</p>
        </div>

        {isOverflowing && (
          <button className="read-more-btn" onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? (
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                Read Less <ChevronUp size={16} />
              </span>
            ) : (
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                Read More <ChevronDown size={16} />
              </span>
            )}
          </button>
        )}
      </motion.div>
    </div>
  )
}

export default FastFacts
